var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z",
    fill: "url(#paint0_linear_139_2818)",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_139_2818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 48C16 30.3269 30.3269 16 48 16C65.6731 16 80 30.3269 80 48C80 65.6731 65.6731 80 48 80C30.3269 80 16 65.6731 16 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 48C16.5 30.603 30.603 16.5 48 16.5C65.397 16.5 79.5 30.603 79.5 48C79.5 65.397 65.397 79.5 48 79.5C30.603 79.5 16.5 65.397 16.5 48Z",
    stroke: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 60C41.3724 60 36 54.6276 36 48C36 41.3724 41.3724 36 48 36C54.6276 36 60 41.3724 60 48C60 54.6276 54.6276 60 48 60ZM48 57.6C50.5461 57.6 52.9879 56.5886 54.7882 54.7882C56.5886 52.9879 57.6 50.5461 57.6 48C57.6 45.4539 56.5886 43.0121 54.7882 41.2118C52.9879 39.4114 50.5461 38.4 48 38.4C45.4539 38.4 43.0121 39.4114 41.2118 41.2118C39.4114 43.0121 38.4 45.4539 38.4 48C38.4 50.5461 39.4114 52.9879 41.2118 54.7882C43.0121 56.5886 45.4539 57.6 48 57.6ZM46.8 48.9504C46.1683 48.6747 45.6508 48.1899 45.3345 47.5776C45.0183 46.9652 44.9225 46.2626 45.0633 45.5879C45.2041 44.9132 45.5729 44.3076 46.1078 43.8729C46.6426 43.4382 47.3108 43.2009 48 43.2009C48.6892 43.2009 49.3574 43.4382 49.8922 43.8729C50.4271 44.3076 50.7959 44.9132 50.9367 45.5879C51.0775 46.2626 50.9817 46.9652 50.6655 47.5776C50.3492 48.1899 49.8317 48.6747 49.2 48.9504V52.8H46.8V48.9504Z",
    fill: "#525866"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_139_2818",
    x: 14,
    y: 15,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0784314 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_2818"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_2818",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_139_2818",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717784",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/ResetPassword.b384445f063733e6c4274b86aecd9518.svg";
export { ForwardRef as ReactComponent };